import { createActionPayload, ActionsUnion } from "./actions";
import {
  Pagination,
  TestCaseIndex,
  Requirements,
  Diff,
  SuiteContext
} from "./entity";
import {
  TestCase,
  User,
  ProjectSuiteTree,
  Requirement,
  Tag,
  TestCaseRevision,
  FilterQuery
} from "../../../services/generated-sdk/models";
import test_case_columns from "../../common/test_case_columns";
import * as _ from "lodash";
import { notification } from "antd";
interface selectedFilterPayload {
  selectedFilter: number;
  appliedFilters: Array<FilterQuery>;
}
const ACTION_SET_COUNT = "ACTION_SET_COUNT";
const ACTION_SET_LOADING = "ACTION_SET_LOADING";
const ACTION_SET_PAGINATION = "ACTION_SET_PAGINATION";
const ACTION_SET_TESTCASES = "ACTION_SET_TESTCASES";
const ACTION_SET_TESTCASES_COUNT = "ACTION_SET_TESTCASES_COUNT";
const ACTION_SET_SEARCH_TEXT = "ACTION_SET_SEARCH_TEXT";
const ACTION_SET_REQUIREMENT_STATUS = "ACTION_SET_REQUIREMENT_STATUS";
const ACTION_SET_VISIBLE_COLUMNS = "ACTION_SET_VISIBLE_COLUMNS";
const ACTION_SET_SELECTED_TEST_CASE = "ACTION_SET_SELECTED_TEST_CASE";
const ACTION_SET_EXECUTION_HISTORY = "ACTION_SET_EXECUTION_HISTORY";
const ACTION_SET_EXECUTION_HISTORY_LOADING =
  "ACTION_SET_EXECUTION_HISTORY_LOADING";
const ACTION_SET_CHANGE_LOG = "ACTION_SET_CHANGE_LOG";
const ACTION_SET_CHANGE_LOG_LOADING = "ACTION_SET_CHANGE_LOG_LOADING";
const ACTION_SET_REQUIREMENTS = "ACTION_SET_REQUIREMENTS";
const ACTION_SET_REQUIREMENTS_LOADING = "ACTION_SET_REQUIREMENTS_LOADING";
const ACTION_SET_DIFF_LOADING = "ACTION_SET_DIFF_LOADING";
const ACTION_SET_DIFF = "ACTION_SET_DIFF";
const ACTION_SET_SELECTED_SUIT = "ACTION_SET_SELECTED_SUIT";
const ACTION_TOGGLE_COLUMN_SELECTOR = "ACTION_TOGGLE_COLUMN_SELECTOR";
const ACTION_SET_ACTIVE_PANEL_TAB = "ACTION_SET_ACTIVE_PANEL_TAB";
const ACTION_TOGGLE_SUITE_PANEL = "ACTION_TOGGLE_SUITE_PANEL";
const ACTION_SELECT_FILTER = "ACTION_SELECT_FILTER";
const ACTION_REMOVE_FILTER = "ACTION_REMOVE_FILTER";
const ACTION_DESELECT_FILTER = "ACTION_DESELECT_FILTER";
const ACTION_UPDATE_FILTER_TYPE = "ACTION_UPDATE_FILTER_TYPE";
const ACTION_UPDATE_FILTERS = "ACTION_UPDATE_FILTERS";
const ACTION_SWITCH_EXECUTION_MODAL = "ACTION_SWITCH_EXECUTION_MODAL";
const ACTION_SWITCH_QUICK_ADD_FORM = "ACTION_SWITCH_QUICK_ADD_FORM";
const ACTION_SET_NOT_LINKED_SUITES = "ACTION_SET_NOT_LINKED_SUITES";
const ACTION_USER_SUITE_EXPANDED = "ACTION_USER_SUITE_EXPANDED";
const ACTION_SET_SHOW_IMMEDIATE_CHILDREN = "ACTION_SET_SHOW_IMMEDIATE_CHILDREN";
const ACTION_SET_SORTING_STATUS = "ACTION_SET_SORTING_STATUS";
const ACTION_SET_DRAGGED_TEST_CASE = "ACTION_SET_DRAGGED_TEST_CASE";
const ACTION_SHOW_SUIT_LAYOUT_OPTION = "ACTION_SHOW_SUIT_LAYOUT_OPTION";
const ACTION_SET_SUITS = "ACTION_SET_SUITS";
const ACTION_SET_TAGS = "ACTION_SET_TAGS";
const ACTION_SET_MEMBERS = "ACTION_SET_MEMBERS";
const ACTION_SET_ADD_PERMISSION = "ACTION_SET_ADD_PERMISSION";
const ACTION_ADD_FILTER = "ACTION_ADD_FILTER";
const ACTION_UPDATE_FILTER_VALUES = "ACTION_UPDATE_FILTER_VALUES";
const ACTION_SWITCH_SUITE_FORM = "ACTION_SWITCH_SUITE_FORM";
const ACTION_SET_ADDING_SUITE = "ACTION_SET_ADDING_SUITE";
const SHOW_TEST_CASE_IN_TREE = "SHOW_TEST_CASE_IN_TREE";
const ACTION_SET_SELECTION_STATE = "ACTION_SET_SELECTION_STATE";
const ACTION_SET_SELECT_TC = "ACTION_SET_SELECT_TC";
const ACTION_TOGGLE_FILTER_TAB = "ACTION_TOGGLE_FILTER_TAB";
const ACTION_RESET_FILTER = "ACTION_RESET_FILTER";
const ACTION_SET_SUITE_PANEL_COLLAPSED = "ACTION_SET_SUITE_PANEL_COLLAPSED";
const ACTION_SET_SELECTED_FILTER = "ACTION_SET_SELECTED_FILTER";

export const Actions = {
  setCount: createActionPayload<typeof ACTION_SET_COUNT, number>(
    ACTION_SET_COUNT
  ),
  setLoading: createActionPayload<typeof ACTION_SET_LOADING, boolean>(
    ACTION_SET_LOADING
  ),
  setSelectedFilter: createActionPayload<
    typeof ACTION_SET_SELECTED_FILTER,
    selectedFilterPayload
  >(ACTION_SET_SELECTED_FILTER),
  resetFilter: createActionPayload<typeof ACTION_RESET_FILTER, undefined>(
    ACTION_RESET_FILTER
  ),
  toggleFilterTab: createActionPayload<
    typeof ACTION_TOGGLE_FILTER_TAB,
    undefined
  >(ACTION_TOGGLE_FILTER_TAB),
  setSelectTestCases: createActionPayload<
    typeof ACTION_SET_SELECT_TC,
    (param: any) => void
  >(ACTION_SET_SELECT_TC),
  setAddingSuite: createActionPayload<typeof ACTION_SET_ADDING_SUITE, boolean>(
    ACTION_SET_ADDING_SUITE
  ),
  onShowTestCasesInTree: createActionPayload<
    typeof SHOW_TEST_CASE_IN_TREE,
    boolean
  >(SHOW_TEST_CASE_IN_TREE),
  switchSuiteAddForm: createActionPayload<
    typeof ACTION_SWITCH_SUITE_FORM,
    boolean
  >(ACTION_SWITCH_SUITE_FORM),
  setAddPermission: createActionPayload<
    typeof ACTION_SET_ADD_PERMISSION,
    boolean
  >(ACTION_SET_ADD_PERMISSION),
  setPagination: createActionPayload<typeof ACTION_SET_PAGINATION, object>(
    ACTION_SET_PAGINATION
  ),
  setTestCases: createActionPayload<typeof ACTION_SET_TESTCASES, TestCase[]>(
    ACTION_SET_TESTCASES
  ),
  setSearchText: createActionPayload<typeof ACTION_SET_SEARCH_TEXT, string>(
    ACTION_SET_SEARCH_TEXT
  ),
  setRequirementStatus: createActionPayload<
    typeof ACTION_SET_REQUIREMENT_STATUS,
    boolean
  >(ACTION_SET_REQUIREMENT_STATUS),
  setVisibleColumns: createActionPayload<
    typeof ACTION_SET_VISIBLE_COLUMNS,
    Array<string>
  >(ACTION_SET_VISIBLE_COLUMNS),
  setSelectedTestCase: createActionPayload<
    typeof ACTION_SET_SELECTED_TEST_CASE,
    object
  >(ACTION_SET_SELECTED_TEST_CASE),
  setStateForSelection: createActionPayload<
    typeof ACTION_SET_SELECTION_STATE,
    object
  >(ACTION_SET_SELECTION_STATE),
  setTestCaseCount: createActionPayload<
    typeof ACTION_SET_TESTCASES_COUNT,
    number
  >(ACTION_SET_TESTCASES_COUNT),
  setExecutionHistory: createActionPayload<
    typeof ACTION_SET_EXECUTION_HISTORY,
    []
  >(ACTION_SET_EXECUTION_HISTORY),
  setExecutionLoading: createActionPayload<
    typeof ACTION_SET_EXECUTION_HISTORY_LOADING,
    object
  >(ACTION_SET_EXECUTION_HISTORY_LOADING),
  setChangeLog: createActionPayload<
    typeof ACTION_SET_CHANGE_LOG,
    TestCaseRevision[]
  >(ACTION_SET_CHANGE_LOG),
  setChangeLogLoading: createActionPayload<
    typeof ACTION_SET_CHANGE_LOG_LOADING,
    object
  >(ACTION_SET_CHANGE_LOG_LOADING),
  setRequirements: createActionPayload<
    typeof ACTION_SET_REQUIREMENTS,
    Requirement[]
  >(ACTION_SET_REQUIREMENTS),
  setRequirementsLoading: createActionPayload<
    typeof ACTION_SET_REQUIREMENTS_LOADING,
    object
  >(ACTION_SET_REQUIREMENTS_LOADING),
  suitSelected: createActionPayload<typeof ACTION_SET_SELECTED_SUIT, object>(
    ACTION_SET_SELECTED_SUIT
  ),
  toggleColumnSelector: createActionPayload<
    typeof ACTION_TOGGLE_COLUMN_SELECTOR,
    null
  >(ACTION_TOGGLE_COLUMN_SELECTOR),
  toggleSuitePanel: createActionPayload<typeof ACTION_TOGGLE_SUITE_PANEL, null>(
    ACTION_TOGGLE_SUITE_PANEL
  ),
  setSuitePanelCollapsed: createActionPayload<
    typeof ACTION_SET_SUITE_PANEL_COLLAPSED,
    boolean
  >(ACTION_SET_SUITE_PANEL_COLLAPSED),
  setDiffLoading: createActionPayload<typeof ACTION_SET_DIFF_LOADING, object>(
    ACTION_SET_DIFF_LOADING
  ),
  setDiff: createActionPayload<typeof ACTION_SET_DIFF, Diff>(ACTION_SET_DIFF),
  addFilter: createActionPayload<typeof ACTION_ADD_FILTER, object>(
    ACTION_ADD_FILTER
  ),
  setFilterValues: createActionPayload<
    typeof ACTION_UPDATE_FILTER_VALUES,
    FilterQuery
  >(ACTION_UPDATE_FILTER_VALUES),
  setActivePanelTab: createActionPayload<
    typeof ACTION_SET_ACTIVE_PANEL_TAB,
    string
  >(ACTION_SET_ACTIVE_PANEL_TAB),
  updateFilters: createActionPayload<typeof ACTION_UPDATE_FILTERS, object>(
    ACTION_UPDATE_FILTERS
  ),
  selectFilter: createActionPayload<typeof ACTION_SELECT_FILTER, object>(
    ACTION_SELECT_FILTER
  ),
  removeFilter: createActionPayload<typeof ACTION_REMOVE_FILTER, object>(
    ACTION_REMOVE_FILTER
  ),
  deselectFilter: createActionPayload<typeof ACTION_DESELECT_FILTER, null>(
    ACTION_DESELECT_FILTER
  ),
  updateFilter: createActionPayload<typeof ACTION_UPDATE_FILTER_TYPE, string>(
    ACTION_UPDATE_FILTER_TYPE
  ),
  swithcExecutionModal: createActionPayload<
    typeof ACTION_SWITCH_EXECUTION_MODAL,
    boolean
  >(ACTION_SWITCH_EXECUTION_MODAL),
  switchQuickAddForm: createActionPayload<
    typeof ACTION_SWITCH_QUICK_ADD_FORM,
    boolean
  >(ACTION_SWITCH_QUICK_ADD_FORM),
  setNotLinkedSuites: createActionPayload<
    typeof ACTION_SET_NOT_LINKED_SUITES,
    ProjectSuiteTree[]
  >(ACTION_SET_NOT_LINKED_SUITES),
  setTags: createActionPayload<typeof ACTION_SET_TAGS, Tag[]>(ACTION_SET_TAGS),
  setMembers: createActionPayload<typeof ACTION_SET_MEMBERS, User[]>(
    ACTION_SET_MEMBERS
  ),
  userSuiteExpanded: createActionPayload<
    typeof ACTION_USER_SUITE_EXPANDED,
    number
  >(ACTION_USER_SUITE_EXPANDED),
  setShowImmediateChildren: createActionPayload<
    typeof ACTION_SET_SHOW_IMMEDIATE_CHILDREN,
    boolean
  >(ACTION_SET_SHOW_IMMEDIATE_CHILDREN),
  setSortingStatus: createActionPayload<
    typeof ACTION_SET_SORTING_STATUS,
    boolean
  >(ACTION_SET_SORTING_STATUS),
  setDraggedTestCase: createActionPayload<
    typeof ACTION_SET_DRAGGED_TEST_CASE,
    TestCase | null
  >(ACTION_SET_DRAGGED_TEST_CASE),
  switchSuiteLayoutOptions: createActionPayload<
    typeof ACTION_SHOW_SUIT_LAYOUT_OPTION,
    boolean
  >(ACTION_SHOW_SUIT_LAYOUT_OPTION),
  setSuites: createActionPayload<typeof ACTION_SET_SUITS, object>(
    ACTION_SET_SUITS
  )
};

export type AcceptedActions = ActionsUnion<typeof Actions>;

export function suiteTreeReducer(
  state: SuiteContext,
  action: AcceptedActions
): SuiteContext {
  switch (action.type) {
    case ACTION_SET_ADDING_SUITE:
      return {
        ...state,
        addingSuite: action.payload == true
      };

    case ACTION_SET_SELECTED_SUIT:
      return {
        ...state,
        selectedSuite: action.payload["selectedSuite"]
      };
    case ACTION_SET_SUITS:
      return {
        ...state,
        suites: action.payload["suites"],
        suitesLoading: false
      };
    case ACTION_SET_SORTING_STATUS:
      return {
        ...state,
        isSorting: action.payload
        // draggedTestCase: null
      };
  }
}

export function testCaseIndexReducer(
  state: TestCaseIndex,
  action: AcceptedActions
): TestCaseIndex {
  switch (action.type) {
    case ACTION_SET_COUNT:
      return {
        ...state,
        count: action.payload,
        pagination: { ...state.pagination, total: action.payload }
      };
    case ACTION_RESET_FILTER:
      return {
        ...state,
        filters: {
          filterType: "AND",
          selected: false,
          appliedFilters: []
        }
      };
    case ACTION_SET_SELECTION_STATE:
      return {
        ...state,
        ...action.payload
      };
    case ACTION_SET_SELECTED_FILTER:
      const appliedFilters = action.payload["appliedFilters"].filter(function(
        element
      ) {
        return element !== undefined;
      });
      console.log("APPL", appliedFilters);
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedFilter: action.payload["selectedFilter"],
          appliedFilters
        }
      };
    case ACTION_ADD_FILTER:
      let filterObj = {};
      // console.log('ACTION', action.payload);
      if (action.payload["type"]) {
        if (
          action.payload["field"] &&
          typeof action.payload["field"] == "object"
        ) {
          const splits = action.payload["field"]["name"].split("_");
          let type = splits && splits[1] ? splits[1] : "text";
          type = type == "dropdown" ? "option" : type;
          // alert(type);
          if (!type) {
            return;
          }
          filterObj = {
            field: action.payload["field"]["name"],
            fieldLabel: action.payload["field"]["label"],
            filter: { type, value: action.payload["field"]["extra"] },
            selected: true
          };
        } else {
          return;
        }
      } else {
        const fields = _.keyBy(test_case_columns.getColumns(), "dataIndex");
        const fieldInfo = fields[action.payload["field"]];
        // console.log('FFFF', fieldInfo);
        if (fieldInfo && fieldInfo.filter) {
          filterObj = {
            field: fieldInfo.filterName || action.payload["field"],
            fieldLabel: fieldInfo.title,
            filter: {
              type: fieldInfo.filter.type,
              value: fieldInfo.filter.filterOptions
                ? fieldInfo.filter.filterOptions
                : {}
            },
            selected: true
          };
        } else {
          return;
        }
      }
      let c_appliedFilters = _.clone(state.filters.appliedFilters);
      //const selected = c_appliedFilters.push(filterObj) - 1;
      const selected = c_appliedFilters.length;
      return {
        ...state,
        filters: {
          ...state.filters,
          appliedFilters: c_appliedFilters,
          selected: selected > 0
        }
      };

    case ACTION_SET_LOADING:
      return {
        ...state,
        loading: action.payload == true
      };
    case SHOW_TEST_CASE_IN_TREE:
      return {
        ...state,
        displayTestCasesInTree: action.payload == true
      };
    case ACTION_SWITCH_SUITE_FORM:
      return {
        ...state,
        suiteAddFormVisible: action.payload == true
      };
    case ACTION_SET_ADDING_SUITE:
      return {
        ...state,
        addingSuite: action.payload == true
      };
    case ACTION_TOGGLE_FILTER_TAB:
      return {
        ...state,
        displayFilterBar: !state.displayFilterBar
      };
    case ACTION_SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload
        }
      };
    case ACTION_SET_TESTCASES:
      return {
        ...state,
        testCases: action.payload
      };
    case ACTION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload
      };
    case ACTION_SET_SELECT_TC:
      return {
        ...state,
        selectTestCases: action.payload
      };
    case ACTION_SET_REQUIREMENT_STATUS:
      return {
        ...state,
        requirementStatus: action.payload
      };
    case ACTION_SET_VISIBLE_COLUMNS:
      let data = localStorage.getItem("testCaseManageData");
      // if (
      //   action.payload &&
      //   action.payload instanceof Array &&
      //   action.payload.length <= 0
      // ) {
      //   notification.warn({ message: "You cannot deselect all columns" });
      //   return state;
      // }
      try {
        //const dataToStore: object = JSON.parse(data || "") || {};
        //commented this due to JSON.parse error - unexpected end of data at line 1 column 1 of the JSON data
        const dataToStore: object =
          data == undefined || data == null ? {} : JSON.parse(data);
        localStorage.setItem(
          "testCaseManageData",
          JSON.stringify(
            typeof dataToStore === "object"
              ? { ...dataToStore, visibleColumns: action.payload }
              : { visibleColumns: action.payload }
          )
        );
      } catch (e) {
        console.log("Could not store user data", e.message);
      }

      return {
        ...state,
        visibleColumns: action.payload
      };
    case ACTION_SET_SELECTED_TEST_CASE:
      return {
        ...state,
        selectedTestCase: action.payload["selectedTestCase"],
        selectedCaseIndex: action.payload["selectedCaseIndex"]
      };
    case ACTION_SET_EXECUTION_HISTORY:
      return {
        ...state,
        executionHistory: { ...state.executionHistory, history: action.payload }
      };
    case ACTION_SET_EXECUTION_HISTORY_LOADING:
      return {
        ...state,
        executionHistory: {
          ...state.executionHistory,
          loading: action.payload["loading"]
        }
      };
    case ACTION_SET_CHANGE_LOG:
      return {
        ...state,
        changeLog: { ...state.changeLog, changes: action.payload }
      };
    case ACTION_SET_CHANGE_LOG_LOADING:
      return {
        ...state,
        changeLog: {
          ...state.changeLog,
          loading: action.payload["loading"]
        }
      };
    case ACTION_SET_DIFF_LOADING:
      return {
        ...state,
        diff: {
          ...state.diff,
          loading: action.payload["loading"]
        }
      };
    case ACTION_SET_DIFF:
      return {
        ...state,
        diff: action.payload
      };
    case ACTION_SET_REQUIREMENTS:
      return {
        ...state,
        requirements: { ...state.requirements, list: action.payload }
      };
    case ACTION_SET_REQUIREMENTS_LOADING:
      return {
        ...state,
        requirements: {
          ...state.requirements,
          loading: action.payload["loading"]
        }
      };
    case ACTION_SET_SELECTED_SUIT:
      return {
        ...state,
        selectedSuite: action.payload["selectedSuite"]
      };
    case ACTION_SET_SUITS:
      return {
        ...state,
        suites: action.payload["suites"],
        suitesLoading: false
      };
    case ACTION_TOGGLE_COLUMN_SELECTOR:
      return {
        ...state,
        columnSelectorVisible: !state.columnSelectorVisible
      };
    case ACTION_TOGGLE_SUITE_PANEL:
      let __data = localStorage.getItem("testCaseManageData");
      try {
        const __dataToStore = JSON.parse(__data || "") || {};
        localStorage.setItem(
          "testCaseManageData",
          JSON.stringify(
            typeof __data === "object"
              ? {
                  ...__dataToStore,
                  suitePanelCollapsed: !state.suitePanelCollapsed
                }
              : { suitePanelCollapsed: !state.suitePanelCollapsed }
          )
        );
      } catch (e) {}

      return {
        ...state,
        suitePanelCollapsed: !state.suitePanelCollapsed
      };
    case ACTION_SET_SUITE_PANEL_COLLAPSED:
      let local_data = localStorage.getItem("testCaseManageData");
      try {
        const local_dataToStore = JSON.parse(local_data || "") || {};
        localStorage.setItem(
          "testCaseManageData",
          JSON.stringify(
            typeof local_data === "object"
              ? {
                  ...local_dataToStore,
                  suitePanelCollapsed: action.payload
                }
              : { suitePanelCollapsed: action.payload }
          )
        );
      } catch (e) {}
      return {
        ...state,
        suitePanelCollapsed: action.payload
      };
    case ACTION_SET_ACTIVE_PANEL_TAB:
      return {
        ...state,
        testCasePanelActiveTab: action.payload
      };
    case ACTION_SET_TESTCASES_COUNT:
      return {
        ...state,
        count: action.payload
      };
    case ACTION_SELECT_FILTER:
      let _appliedFilters = state.filters.appliedFilters;
      _appliedFilters.map(
        (f, key) => (_appliedFilters[key]["selected"] = false)
      );
      if (action.payload && _appliedFilters[action.payload["filterIndex"]])
        _appliedFilters[action.payload["filterIndex"]]["selected"] = true;

      return {
        ...state,
        filters: {
          ...state.filters,
          appliedFilters: _appliedFilters,
          selected: action.payload["filterIndex"]
        }
      };
    case ACTION_UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          selected: false,
          appliedFilters: action.payload["appliedFilters"]
        }
      };
    case ACTION_UPDATE_FILTER_VALUES:
      let v_appliedFilters = state.filters.appliedFilters;
      //let filterIndex = _.findIndex(v_appliedFilters, { selected: true });
      let filterIndex = 0;

      v_appliedFilters[filterIndex] = action.payload;

      //selectedFilter = payload.selectedFilter

      return {
        ...state,
        filters: { ...state.filters, appliedFilters: v_appliedFilters }
      };

    case ACTION_REMOVE_FILTER:
      let __appliedFilters = [...state.filters.appliedFilters];

      filterIndex = action.payload["filterIndex"];

      if (!__appliedFilters[filterIndex]) return state;

      console.log("Filters B", __appliedFilters);
      __appliedFilters.splice(filterIndex, 1);
      console.log("Filters", __appliedFilters);

      return {
        ...state,
        filters: {
          ...state.filters,
          selected: false,
          appliedFilters: __appliedFilters
        }
      };
    case ACTION_DESELECT_FILTER:
      let current_appliedFilters = state.filters.appliedFilters;

      // 1. get selected filter
      const selectedFilter = _.find(current_appliedFilters, {
        selected: true
      });
      //selectedFilter.selected = false;
      // 2. set values
      return {
        ...state,
        filters: {
          ...state.filters,
          appliedFilters: current_appliedFilters,
          selected: false
        }
      };
    case ACTION_UPDATE_FILTER_TYPE:
      return {
        ...state,
        filters: { ...state.filters, filterType: action.payload }
      };
    case ACTION_SWITCH_EXECUTION_MODAL:
      return {
        ...state,
        showExecutionModal: action.payload == true
      };
    case ACTION_SWITCH_QUICK_ADD_FORM:
      return {
        ...state,
        showQuickAddForm: action.payload == true
      };
    case ACTION_SET_NOT_LINKED_SUITES:
      return {
        ...state,
        notLinkedSuites: action.payload
      };
    case ACTION_SET_TAGS:
      return {
        ...state,
        tags: action.payload
      };
    case ACTION_SET_MEMBERS:
      return {
        ...state,
        members: action.payload
      };
    case ACTION_SET_ADD_PERMISSION:
      return {
        ...state,
        canAddTestCase: action.payload
      };
    case ACTION_USER_SUITE_EXPANDED:
      return {
        ...state,
        userExpandedSuite: action.payload
      };
    case ACTION_SET_SHOW_IMMEDIATE_CHILDREN:
      return {
        ...state,
        showImmediateChildren: action.payload
      };
    case ACTION_SET_SORTING_STATUS:
      return {
        ...state,
        isSorting: action.payload,
        draggedTestCase: null
      };
    case ACTION_SET_DRAGGED_TEST_CASE:
      return {
        ...state,
        draggedTestCase: action.payload
      };
    case ACTION_SHOW_SUIT_LAYOUT_OPTION:
      console.log({
        ...state,
        showSuiteLayoutOptions: action.payload
      });
      return {
        ...state,
        showSuiteLayoutOptions: action.payload
      };
  }
  return state;
}
